// imageTargetStore.ts
import { ArtworkData } from '../../artworks';

export enum ImageTargetView {
  ONBOARDING,
  SCANNING,
  LOADING,
  VIEWING,
}

interface ImageTargetStoreState {
  imageTarget?: ArtworkData;
  artworkLoading: boolean;
  imageTargetView: ImageTargetView;
  videoElement: HTMLVideoElement | null;
  audioElement: HTMLAudioElement | null;
}

interface ImageTargetStore {
  state: ImageTargetStoreState;
  setImageTarget: (value?: ArtworkData) => void;
  setArtworkLoading: (isLoading: boolean) => void;
  setImageTargetView: (view: ImageTargetView) => void;
  setVideoElement: (el: HTMLVideoElement | null) => void;
  setAudioElement: (el: HTMLAudioElement | null) => void;
}

export const imageTargetStore: ImageTargetStore = {
  state: {
    imageTarget: undefined,
    artworkLoading: false,
    imageTargetView: ImageTargetView.ONBOARDING,
    videoElement: document.getElementById('ej-video') as HTMLVideoElement | null,
    audioElement: document.getElementById('ejx-audio') as HTMLAudioElement | null,
  },
  setImageTarget: () => {},
  setArtworkLoading: () => {},
  setImageTargetView: () => {},
  setVideoElement: () => {},
  setAudioElement: () => {},
};
